export const routes = {
  LANDING: "/",
  LOGIN: "/login",
  REGISTER: "/register",
  HOME: "/home",
  PRODUCTS: "/products",
  DASHBOARD: "/dashboard",
  ADMIN: "/admin/dashboard",
  ADMIN_USERS: "/admin/users",
  ADMIN_PRODUCTS: "/admin/products",
  ADMIN_ORDERS: "/admin/orders",
  ADMIN_VENDORS: "/admin/vendors",
  ADMIN_APPROVALS: "/admin/approvals",
  ADMIN_SETTINGS: "/admin/settings",
  ADMIN_ANALYTICS: "/admin/analytics",
  ADMIN_INVENTORY: "/admin/inventory",
  ADMIN_WAREHOUSE: "/admin/warehouse",
  ADMIN_PROMOTIONS: "/admin/promotions",
  ADMIN_PROFILE: "/admin/profile",
  VENDOR_INVENTORY: "/vendor/inventory",
  VENDOR_COMPANY: "/vendor/company",
  DELIVERY_DASHBOARD: "/delivery/dashboard",
  DELIVERY_SHIPMENTS: "/delivery/shipments",
  SHIPMENT_TRACKING: "/shipment/:id",
  ADMIN_DELIVERY: "/admin/delivery",
  WISHLIST: "/wishlist",
  SUPER_ADMIN: "/super-admin/dashboard",
  DELIVERY_HISTORY: "/delivery/history",
  SUPER_ADMIN_VENDORS: "/super-admin/vendors",
  SUPER_ADMIN_DELIVERY: "/super-admin/delivery",
  CREDIT: "/credit",
  CART: "/cart",
  CHECKOUT: "/checkout",
  ORDERS: "/orders",
  PAYMENT: "/payment/:orderId",
  PROFILE: "/profile",
  SECURITY: "/security",
  HELP: "/help",
};